import { useParams, useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import MyFilesV2ViewModel from '../MyFilesV2/viewModel';
import FileListPage from '../MyFilesV2/FileListPage';
import { Files } from '../../services/journey.service';

export function ExamCategoryPageContent() {
  const { category } = useParams<{ category: string }>();
  const location = useLocation();
  const stateFiles = (location.state as { files?: Files } | null)?.files ?? null;

  const { isLoading, files: fetchedFiles } = MyFilesV2ViewModel();

  const files = fetchedFiles ?? stateFiles;
  const loading = !stateFiles && isLoading;

  return loading ? (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
      <CircularProgress sx={{ color: 'brand.darkGreen' }} />
    </Box>
  ) : (
    <FileListPage files={files} category={category ?? ''} backPath="/meus-exames" />
  );
}
